export default __webpack_public_path__ + "static/media/books.db540be7.png";